import { IconHeartFilled, IconThumbDownFilled, IconThumbUpFilled } from "@tabler/icons-react";

const positiveColor = "green";
const neutralColor = "blue";
const negativeColor = "pink";

export const reactionTypeToColor = {
  positive: positiveColor,
  neutral: neutralColor,
  negative: negativeColor,
};

export const reactionTypeToIcon = {
  positive: IconHeartFilled,
  neutral: IconThumbUpFilled,
  negative: IconThumbDownFilled,
};
